import type { ComputedRef } from 'vue';
import { computed, watch } from 'vue';
import { BetSlipCtaAction } from '@/interface/enum';
import { useQuickDeposit } from '@/libraries/composables/useQuickDeposit';

export interface IBetSlipCtaPresentationInput {
    ctaAction: ComputedRef<BetSlipCtaAction>;
    isCtaDisabled: ComputedRef<boolean>;
    handleCtaClick: () => Promise<void>;
}

export function useBetSlipCtaPresentation(input: IBetSlipCtaPresentationInput) {
    const { clickDeposit, isQuickDepositLoaded, loadQuickDepositScript } = useQuickDeposit();
    const renderedCtaAction = computed(() => (
        input.ctaAction.value === BetSlipCtaAction.Deposit && !isQuickDepositLoaded.value
            ? BetSlipCtaAction.PlaceBet
            : input.ctaAction.value
    ));
    const isRenderedCtaDisabled = computed(() => (
        input.isCtaDisabled.value
        || (
            input.ctaAction.value === BetSlipCtaAction.Deposit
            && !isQuickDepositLoaded.value
        )
    ));

    watch(
        () => input.ctaAction.value === BetSlipCtaAction.Deposit,
        async (isDepositRequired) => {
            if (isDepositRequired) {
                await loadQuickDepositScript();
            }
        },
        { immediate: true },
    );

    async function handleRenderedCtaClick() {
        if (isRenderedCtaDisabled.value) {
            return;
        }
        if (input.ctaAction.value === BetSlipCtaAction.Deposit) {
            await clickDeposit();
            return;
        }
        await input.handleCtaClick();
    }

    return {
        renderedCtaAction,
        isRenderedCtaDisabled,
        handleRenderedCtaClick,
    };
}
